import type { Lesson } from '../schema.js';

export const OBJECTIVE_LESSONS: Lesson[] = [
  {
    id: 'control-center',
    slug: 'objectives-control-center',
    title: 'Control the center',
    audienceLevel: 'beginner',
    concepts: ['board-control'],
    steps: [
      {
        kind: 'explain',
        title: 'Why the center matters',
        body: 'The four middle squares — d4, e4, d5, e5 — are the most important on the board. A piece in the center controls more squares than a piece on the edge.',
        narration: 'The center is the most powerful part of the board.',
      },
      {
        kind: 'drill',
        task: 'legal-move',
        free: true,
        title: 'Feel the center',
        body: 'Move any piece and watch the control map change. Try to control the center squares!',
        fen: '4k3/8/8/8/8/8/PPP4P/4K3 w - - 0 1',
      },
      {
        kind: 'quiz',
        title: 'Center check',
        body: 'A quick check on the center.',
        questions: [
          { prompt: 'Which square is in the center of the board?', choices: ['a1', 'e4', 'h8'], correct: 1 },
          { prompt: 'Why is the center important?', choices: ['It is closer to your own king', 'Center pieces control many squares'], correct: 1 },
        ],
      },
    ],
  },
  {
    id: 'defend-pieces',
    slug: 'objectives-defend-pieces',
    title: 'Keep your pieces safe',
    audienceLevel: 'beginner',
    concepts: ['defense'],
    steps: [
      {
        kind: 'explain',
        title: 'Do not give pieces away',
        body: 'A hanging piece is one the enemy can capture for free. Before you move, always check: is this piece safe?',
        narration: 'Never let a piece be captured for free.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Save your knight',
        body: 'Your knight on c3 is attacked by a black knight. Make the best move to save it.',
        fen: '4k3/8/8/8/4n3/2N5/8/4K3 w - - 0 1',
        answer: ['Nxe4'],
        hint: 'Your knight can capture the attacking knight.',
      },
    ],
  },
  {
    id: 'develop-fast',
    slug: 'objectives-develop-fast',
    title: 'Bring your army out',
    audienceLevel: 'beginner',
    concepts: ['development'],
    steps: [
      {
        kind: 'explain',
        title: 'Develop your pieces early',
        body: 'At the start of the game, bring out your knights and bishops before you move pawns again. More pieces in the fight means more power.',
        narration: 'Develop your pieces quickly in the opening.',
      },
      {
        kind: 'quiz',
        title: 'Opening check',
        body: 'A quick check on your opening.',
        questions: [
          {
            prompt: 'What should you do first in the game?',
            choices: ['Move your knights and bishops out', 'Move only your king', 'Move the same pawn three times'],
            correct: 0,
          },
          {
            prompt: 'Why develop quickly?',
            choices: ['More pieces in the fight', 'Your pieces get lonely'],
            correct: 0,
          },
        ],
      },
    ],
  },
  {
    id: 'castle-early',
    slug: 'objectives-king-safety',
    title: 'Keep your king safe',
    audienceLevel: 'beginner',
    concepts: ['king-safety'],
    steps: [
      {
        kind: 'explain',
        title: 'Castle to protect the king',
        body: 'Castling tucks your king into a corner and brings a rook out. It is the best way to keep your king safe in the opening.',
        narration: 'Castle early to keep your king safe.',
      },
      {
        kind: 'drill',
        task: 'best-move',
        title: 'Castle for safety',
        body: 'Your king is in the middle of the board. Castle to keep it safe!',
        fen: 'r3k2r/8/8/8/8/8/8/R3K2R w KQkq - 0 1',
        answer: ['O-O'],
        hint: 'Move your king two squares toward your kingside rook.',
      },
    ],
  },
];
